import { AvailableThemes } from 'fe-lib-theme-types';
import { getThemeProvider } from './getThemeProvider';
import { withHsTheme } from './withHsTheme';
import { brand2020Switch } from './brand2020Switch';
import { deprecateFn } from './deprecateFn';
import { use } from './useTheme';
import { ThemeContext } from './theme-context';

const { getThemeValue, getIsBrand2020Active, subscribe } = getThemeProvider();

const useTheme = deprecateFn(
  withHsTheme,
  'useTheme has been deprecated, replace with withHsTheme (backwards compatible)',
);

export {
  getThemeValue,
  getIsBrand2020Active,
  subscribe,
  useTheme,
  withHsTheme,
  brand2020Switch,
  AvailableThemes,
  ThemeContext,
  use,
};
